export default __webpack_public_path__ + "newsletter_headlines.png";